<template lang="pug">
  div
    Header
    el-main
      router-view(@setData='setData', :data='data')
</template>

<script>
import Header from './Header.vue'
import Cookies from 'js-cookie'
export default {
  name: 'Join',
  components: {
    Header
  },
  data () {
    return {
      data: {},
    }
  },
  methods: {
    setData (data) {
      console.log(data, "data")
      this.data = data
    },
  },
  created() {
    let phone = Cookies.get('phone');
    console.log("Cookies.get('phone')", phone)
    if(phone){
      this.$router.replace({ name: 'info' })
    }else{
      this.$router.replace({ name: 'JoinInfo' })
    }
  },
}
</script>
<style scoped>
@media (min-width: 900px) {
  .el-form-item {
      margin: 0 6vw;
  }
}
</style>